import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

function Contact() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  return (
    <motion.div 
      className="contact"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="contact-container">
        <motion.div
          className="contact-header"
          variants={itemVariants}
        >
          <h1 className="contact-title">Contact</h1>
          <div className="contact-decorative-line"></div>
        </motion.div>
        <motion.div 
          className="contact-content"
          variants={containerVariants}
        >
          <div className="contact-email">
            <a href="mailto:contact@mariemercier.studio" className="contact-email-link">
              contact@mariemercier.studio
            </a>
          </div>
          <div className="contact-socials">
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-social-link"
            >
              Instagram
            </a>
            <a 
              href="https://linkedin.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-social-link"
            >
              LinkedIn
            </a>
          </div>
          <div className="contact-cv">
            <p className="contact-cv-text">
              Clients : Luxe, Mode, Culture • Expertises : Identité visuelle, Direction artistique, Édition
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default Contact;

